var map = {
	"./bg.png": "d68e",
	"./logo.png": "cf05",
	"./mianshi-1.jpeg": "e9ac",
	"./oee-1.png": "6e50",
	"./oee-2.png": "5809",
	"./oee-3.png": "b0c4",
	"./oee-4.png": "6fd1",
	"./p-kb-1.png": "591c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";